/**
 * Import required libraries
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import { getLabel } from "Utils";
import { chat as chatApi } from "api";

/**
 * Import required elements
 */
import { Button } from "@material-ui/core";
import Selection from "./lib/selection";
import { AvatarIcon } from "Components";

import styles from "./styles";

/**
 * Privates Component
 */
function Privates({ users, back, lang, close, user, ...props }) {
  
  const [roomName, setRoomName] = useState("");
  const [roomUsers, setRoomUsers] = useState([]);

  const addUser = uid => event => {
    setRoomUsers(prev => {
      if(prev.includes(uid)) {
        return prev.filter(e => e !== uid);
      } else return [...prev, uid];
    });
  }

  const createChatRoom = event => {

    //On doit récupérer l'id du créé afin de mettre sa visibilité à true

    event.preventDefault();
    chatApi.init({
      name: roomName,
      users: roomUsers
    }).then((res) => {
      props.popupProps.makeVisible(res,true)
      close(event); //Provoque un warning à cause de la gestion de l'event et du preventDefault
    }).catch(console.error);

    

  }

  const classes = styles();

  return (
    <div className={classes.privateContainer}>
      <Selection
        title={labels.title}
        back={back}
        inputs={[{
          type: "text",
          label: getLabel({en: "Name of the chat", fr: "Nom de la boite de conversation"}, lang, "Footer/NewChat/Privates"),
          value: roomName,
          onChange: e => setRoomName(e.target.value)
        }]}
        list={Object.values(users).filter((item) => {return item.uid !== user.userUid && item.group === user.groupUid}).map(u => 
          ({
          key: u.uid,
          onClick: addUser(u.uid),
          selected: roomUsers.includes(u.uid),
          icon: (
            <AvatarIcon userUid={u.uid}
              iconProps={{style: styleAvatar}}
            />
          ),
          label: `@${u.pseudo}`
        })
        )}
      />
      <Button size="small"
        variant="contained"
        color="primary"
        onClick={createChatRoom}
        disabled={roomName === "" || roomName.length > 20}
      >
        {getLabel({
          en: "Create",
          fr: "Créer"
        }, lang, "Footer/NewChat/Privates")}
      </Button>
    </div>
  );
}

const labels = {
  title: {
    en: "Privates",
    fr: "Privés"
  }
};

const styleAvatar = {
  width: 20,
  height: 20,
  marginRight: 10
};

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang,
  users: state.list.user,
  user: state.user
}))(Privates);
